import { FooterConfig } from "../globals";
import { MAIN_SOCIALS } from "./socials";

export const FOOTER_CONFIG: FooterConfig = {
  // socials: Object.keys(MAIN_SOCIALS).map((k) => MAIN_SOCIALS[k]),
};
